import { useEffect } from "react";

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    return () => setMeta("robots", "index, follow");
  }, [title, description, noindex]);
  return null;
}
